import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@americanexpress/dls-react';
import { Helmet } from 'react-helmet';
import childRoutes from '../childRoutes';
import Header from './Header';
import TokenContextProvider from '../utility/TokenContext';
import BankContextProvider from '../utility/BankContext';
import PaymentContextProvider from '../utility/PaymentContext';
import AmountSelectedContextProvider from '../utility/AmountSelectedContext';
import DateContextProvider from '../utility/DateContext';

const Mmvr = ({ languageData, locale, children }) => {
  if (typeof window !== 'undefined') {
    const styleId = 'datepicker-width-override';
    if (!document.querySelector(`#${styleId}`)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
      .css-9pilho-DatePicker {
        max-width: none !important;
        width: 100% !important;
      }
    `;
      document.head.appendChild(style);
    }
  }
  if (Object.entries(languageData).length === 0) {
    return <ProgressCircle />;
  }

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <Helmet
        htmlAttributes={{ lang: locale }}
        link={[
          {
            rel: 'icon',
            type: 'image/png',
            href: 'https://www.americanexpress.com/favicon.ico',
          },
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.21.5/package/dist/6.21.5/styles/dls.min.css',
          },
        ]}
        title="MMVR - American Express"
      >
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="referrer" content="origin-when-cross-origin" />
      </Helmet>
      <TokenContextProvider>
        <PaymentContextProvider>
          <BankContextProvider>
            <AmountSelectedContextProvider>
              <DateContextProvider>
                <div className="dls-gray-02-bg" style={{ minHeight: '100vh' }}>
                  <Header />
                  {children}
                  {/* <Footer /> */}
                </div>
              </DateContextProvider>
            </AmountSelectedContextProvider>
          </BankContextProvider>
        </PaymentContextProvider>
      </TokenContextProvider>
    </IntlProvider>
  );
};

export const TestableMmvr = Mmvr;

Mmvr.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
Mmvr.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require -- require needs to be inside browser check
  Mmvr.appConfig = require('../appConfig').default;
}

export const loadModuleData = ({ store: { dispatch } }) => dispatch(loadLanguagePack('multi-model-voice-response-application', { fallbackLocale: 'en-US' }));

Mmvr.holocron = {
  name: 'multi-model-voice-response-application',
  loadModuleData,
};

export default oneAppModuleWrapper('multi-model-voice-response-application')(Mmvr);
